import _ from 'lodash';
import React from 'react';
import { Route, Switch } from 'react-router';

import { NotFound } from 'src/components/common/notFound/NotFound';
import { DocumentTitle } from 'src/components/documentTitle/DocumentTitle';
import { PermissionBlockCard } from 'src/components/permissionGuards/permissionBlockCard/PermissionBlockCard';
import { PermissionGuard } from 'src/components/permissionGuards/permissionGuard/PermissionGuard';
import { useRouteParams } from 'src/hooks/useRouteParams';

import {
  proposalCheckDetailsRouteConfig,
  proposalCheckRouteConfig,
  proposalCheckSchemasRouteConfig,
  proposalCheckTasksRouteConfig,
} from '../routes';
import { NonPublicGraphArea } from '../variantLayout/NonPublicGraphArea';

import { CheckDetails } from './CheckDetails/CheckDetails';
import { CheckSchemas } from './CheckSchemas/CheckSchemas';
import { CheckTasks } from './CheckTask/CheckTasks';

function ProposalCheckLayoutContent() {
  return (
    <Switch>
      <Route
        path={proposalCheckSchemasRouteConfig.definition}
        component={CheckSchemas}
      />
      <Route
        path={proposalCheckDetailsRouteConfig.definition}
        component={CheckDetails}
      />
      <Route
        path={proposalCheckTasksRouteConfig.definition}
        component={CheckTasks}
      />
      <Route component={NotFound} />
    </Switch>
  );
}

export function ProposalCheckLayout() {
  const { graphId, graphVariant } = useRouteParams(proposalCheckRouteConfig);

  return (
    <div className="h-full bg-primary">
      <DocumentTitle title="Checks">
        <NonPublicGraphArea>
          <PermissionGuard
            graphId={graphId}
            graphVariant={graphVariant}
            graphVariantPermissions="canQueryLaunches"
            fallback={PermissionBlockCard}
          >
            <ProposalCheckLayoutContent />
          </PermissionGuard>
        </NonPublicGraphArea>
      </DocumentTitle>
    </div>
  );
}
